export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: '洞洞杂货铺是一部什么类型的漫画？',
    a: '它是一部以“人情与缺口”为核心的单元剧漫画，每一话通常独立成篇，讲述一位客人、一件缺口的商品与一次等价交换之间的温柔故事。整体氛围温暖略带哀愁，兼具治愈与悬疑元素。',
  },
  {
    q: '“洞洞”到底是什么意思？',
    a: '“洞洞”既指货架上那些看得见的孔洞，也象征生命里一切尚未圆满的空缺——没说完的话、没告别的故人、没做完的梦。漫画的核心主题，正是人如何面对并交换这些“洞”。',
  },
  {
    q: '洞洞杂货铺真的存在吗？它在哪里？',
    a: '在漫画设定里，洞洞杂货铺没有固定地址，它出现在城市里那些被遗忘的街角，只有正在“缺一样东西”的人才会在某个拐角遇见它。它是现实世界与记忆缝隙交汇处的隐秘存在。',
  },
  {
    q: '从第一话开始读还是随便挑一话读？',
    a: '虽然单话可独立阅读，但建议从第一话开始按序阅读。作者早期就埋下了世界观与店主的伏笔，按序阅读能获得更完整的体验。',
  },
  {
    q: '漫画里的交易规则是什么？',
    a: '核心是“一洞换一洞”的等价交换：带走一个空缺的同时，必须留下一段属于自己的空缺。交易必须出于自愿，且记忆不可伪造。',
  },
  {
    q: '这部漫画会更新得很慢吗？',
    a: '作品更新相对稳定，适合作为轻松的日常追更。若要一口气读完，等待一个长假期集中阅读会更有沉浸感。',
  },
];